import Vue from 'vue'
import App from './pages/App.vue'
import router from './router'

Vue.config.productionTip = false;

import axios from "axios";
axios.defaults.baseURL = 'https://house.hytsmart.cn:2023/v1/org/';

import 'element-ui/lib/theme-chalk/index.css';

import ElementUI from 'element-ui';
Vue.use(ElementUI);
//引入 echarts 图表
import * as echarts from 'echarts'
// 为什么加 * as   https://blog.csdn.net/qq_44802808/article/details/112635323
Vue.prototype.$echarts = echarts
axios.interceptors.request.use(config => {
  if (!config.url) {
    return false;
  }
  config.headers.Authorization = localStorage.getItem("token");
  config.headers["X-Ca-Timestamp"] = parseInt(Date.now() / 1000);
  config.headers["PYDDot-Client-Type"] = localStorage.getItem("type");
  config.headers["PYDDot-Org-ID"] = localStorage.getItem("orgID");
  config.headers["Content-Type"] = "application/json";

  if (!config.data) {
    config.data = {};
  }
  config.data.orgID = localStorage.getItem("orgID");

  return config;
});
Vue.directive('focus', {
  inserted: function(el) {
    el.querySelector('input').focus();
  }
});
new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
